import { unaccent } from 'vdlib';
import { I18n as I } from 'react-redux-i18n';

const filterOption = (input, option) => {
  const inputText = unaccent(input).toLowerCase();
  const optionText = unaccent(option.children).toLowerCase();
  return optionText.indexOf(inputText) >= 0;
};

const formatTitle = title =>
  Array.isArray(title) ? title.map(part => I.t(part)).join(' ') : I.t(title);

export { filterOption, formatTitle };
